export default {
    state: () => ({
        demo: 'demo'
    }),
    getters: {
        demo (state) {
            return state.demo
        }
    },
    // _.mapValues({}, x=> _.wrap(x, setStatus))
    actions: {
        async demo ({ commit, dispatch, state }, data = 'set data ...') {
            commit('SET_DEMO', data)
        }
    },
    mutations: {
        SET_DEMO (state, data) {
            state.demo = data
        }
    }
}


// WEBPACK FOOTER //
// ./store/module/common.js